export const generateKey = name => { //NO TOCAR

    if (!name) return name
    const nameNoSpaces = String(name).replace(/[\s]/g, '')
    const noTildes = nameNoSpaces.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

    return noTildes.toLowerCase()
}
